import React from 'react'

interface SelectOption {
	value: string
	label: string
}

interface SelectInputProps {
	value: string
	onChange: (value: string) => void
	options: SelectOption[]
	className?: string
}

export default function SelectInput({ value, onChange, options, className }: SelectInputProps) {
	return (
		<select
			value={value || ''}
			onChange={(e) => onChange(e.target.value)}
			className={
				className ||
				'w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-xs'
			}
		>
			{options.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</select>
	)
}


